import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormDownloadService } from '../form-download.service';

/**
 * Displays markdown/code artifact content with copy and download actions.
 */
@Component({
	selector: 'app-content-viewer',
	templateUrl: './content-viewer.component.html',
	styleUrls: ['./content-viewer.component.scss'],
})
export class ContentViewerComponent {
	// ─── Inputs ────────────────────────────────────────────────────────────────
	@Input() title: string | null = null;
	@Input() content: string | null = null;

	@Output() closed = new EventEmitter<void>();

	// ─── State ─────────────────────────────────────────────────────────────────
	contentCopied = false;

	private downloadService = new FormDownloadService();

	// ─── Public actions ────────────────────────────────────────────────────────

	/** Copies content as plain text (strips markdown formatting) */
	onCopyContent(): void {
		if (!this.content) return;
		const plainText = this.content
			.replace(/#{1,6}\s/g, '')
			.replace(/\*\*(.*?)\*\*/g, '$1')
			.replace(/\*(.*?)\*/g, '$1')
			.replace(/`(.*?)`/g, '$1');
		navigator.clipboard.writeText(plainText).then(() => {
			this.contentCopied = true;
			setTimeout(() => (this.contentCopied = false), 2000);
		});
	}

	/** Downloads the content as a Word document */
	async onDownloadWord(): Promise<void> {
		if (!this.content || !this.title) return;
		await this.downloadService.downloadContentAsWord(this.title, this.content);
	}

	/** Downloads the content as a PDF */
	onDownloadPdf(): void {
		if (!this.content || !this.title) return;
		this.downloadService.downloadContentAsPdf(this.title, this.content);
	}
}
